// extracted by mini-css-extract-plugin
export default {"container":"Container_container__1WgPn","overlay":"Container_overlay__dkVXc","prev":"Container_prev__VGSCc","next":"Container_next__6oL2R"};